import { combineReducers } from 'redux';
import user from './UserReducer';
import pianoTechUser from './PianoTechUserReducer';
import pianoTechCompany from './PianoTechCompanyReducer';
import pianoTechnician from './PianoTechnicianReducer';
import pianoTechCustomer from './PianoTechCustomerReducer';
import pianoTechPiano from './PianoTechPianoReducer';
import pianoTechAppointment from './PianoTechAppointmentReducer';

export default combineReducers({
    user,
    pianoTechUser,
    pianoTechCompany,
    pianoTechnician,
    pianoTechCustomer,
    pianoTechPiano,
    pianoTechAppointment,
});
